export const isValidImageUrl = (url = null) => {
  if (url === undefined || url === null) return false;
  return (url.match(/\.(jpeg|jpg|gif|png)$/) != null);
};

export default isValidImageUrl;
